var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('layout-header',{attrs:{"title":_vm.$route.meta.title}}),_c('div',{staticClass:"layout-content",style:({height:_vm.contentHeight})},[_c('route-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }